// external-referrer.provider.ts
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import {
  EnvironmentProviders,
  inject,
  InjectionToken,
  makeEnvironmentProviders,
  PLATFORM_ID,
  REQUEST,
} from '@angular/core';

export const EXTERNAL_REFERRER = new InjectionToken<string | null>('EXTERNAL_REFERRER');

export function externalReferrerFactory(): string | null {
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    const request = inject(REQUEST);
    const referer = request?.headers?.get('referer');
    const host = request?.headers?.get('host');
    const proto = request?.headers?.get('x-forwarded-proto') ?? 'http';

    if (!referer || !host) return null;

    const currentOrigin = `${proto}://${host}`;

    try {
      return new URL(referer).origin !== currentOrigin ? referer : null;
    } catch {
      return null;
    }
  }

  if (isPlatformBrowser(platformId)) {
    const doc = inject(DOCUMENT);
    const referer = doc.referrer;

    if (!referer) return null;

    return new URL(referer).origin !== doc.location.origin ? referer : null;
  }

  return null;
}

export const EXTERNAL_REFERRER_PROVIDER = {
  provide: EXTERNAL_REFERRER,
  useFactory: externalReferrerFactory,
};

export function provideExternalReferrer(): EnvironmentProviders {
  return makeEnvironmentProviders([EXTERNAL_REFERRER_PROVIDER]);
}
